import cx from "classnames";

import { Models } from "api/types";
import { Icon } from "atoms/icon/Icon";
import ChevronRight from "atoms/icon/icons/chevron_right.svg";
import pluralize from "utils/pluralize";

export interface PastTreatmentCardProps {
  id: string;
  imgUrl?: string | null;
  type: string;
  title: string;
  remainingTreatmentsCount?: number;
  packageUnitType?: Models<"PackageUnitTypeModel"> | null | undefined;
  onClick?: () => void;
  membershipName?: string | null;
  isMemberBenefit?: boolean;
}

// Helper function to clean up membership name by removing trailing "Member" or "Membership"
const cleanMembershipName = (name: string): string => {
  return name
    .replace(/\s+Members?$/i, "")
    .replace(/\s+Memberships?$/i, "")
    .trim();
};

export const PastTreatmentCard = ({
  imgUrl,
  title,
  remainingTreatmentsCount,
  onClick,
  packageUnitType,
  type,
  membershipName,
  isMemberBenefit,
}: PastTreatmentCardProps) => {
  const cleanedMembershipName = membershipName
    ? cleanMembershipName(membershipName)
    : null;

  return (
    <div
      className="flex cursor-pointer items-center justify-between rounded-lg bg-white p-3 transition-all duration-200"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        {/* Smaller image */}
        {imgUrl && (
          <div className="h-16 w-16 flex-shrink-0">
            <img
              className="h-16 w-16 rounded-lg object-cover opacity-90"
              src={imgUrl}
              alt={title}
            />
          </div>
        )}

        {/* Content */}
        <div className="flex flex-col gap-1">
          {/* Membership badge for member benefits - cleaner styling, no icon */}
          {isMemberBenefit && cleanedMembershipName && (
            <span className="text-body3 italic text-secondary">
              From Your {cleanedMembershipName} Membership
            </span>
          )}

          {/* Title */}
          <div className="text-bold2 text-secondary">{title}</div>
        </div>
      </div>

      {/* Chevron */}
      <Icon svg={ChevronRight} size="xsmall" color="brandColor" />
    </div>
  );
};
